import Vue from "vue";
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from "@/core/services/api.service";

import moment from 'moment';
import VueMoment from 'vue-moment';
moment.locale('es');
Vue.use(VueMoment, { moment });

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

Vue.use(PerfectScrollbar);
Vue.config.productionTip = false;

/*axios */
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import 'animate.css';

/*element ui */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/es'
Vue.use(ElementUI, { locale })

import "@/core/plugins/metronic";

//import VueApexCharts from "vue3-apexcharts";

// API service init
ApiService.init();

const publicPages = ['/', '/events', '/detalle', '/login', '/register', '/credential/:id'];
router.beforeEach((to, from, next) => {
  const authRequired = !publicPages.includes(to.path);
  if (authRequired && !store.getters.isAuthenticated) {
    next({ path: '/login' });
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");